import { render, staticRenderFns } from "./PersonelInfo.vue?vue&type=template&id=22376934&scoped=true"
import script from "./PersonelInfo.vue?vue&type=script&lang=ts"
export * from "./PersonelInfo.vue?vue&type=script&lang=ts"
import style0 from "./PersonelInfo.vue?vue&type=style&index=0&id=22376934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22376934",
  null
  
)

export default component.exports